import { apiClient } from "../api";

/**
 * Servicio de usuario (estudiantes, perfil, estado, cambiar clave)
 */

export const getEstudiantes = async () => {
  const { data } = await apiClient.get("usuario/estudiantes");
  return data;
};

export const updateEstadoUsuarioEstudiante = async (userId, status) => {
  const { data } = await apiClient.put(
    `usuario/estado-usuario-estudiante/${userId}`,
    { status }
  );
  return data;
};

export const updatePerfil = async (userId, updatedUser) => {
  const { data } = await apiClient.put(`usuario/perfil/${userId}`, updatedUser);
  return data;
};

export const cambiarClave = async (userId, payload) => {
  const { data } = await apiClient.put(
    `usuario/cambiar-clave/${userId}`,
    payload
  );
  return data;
};

export const aceptarTratamientoDatos = async (userId) => {
  const { data } = await apiClient.put(`usuario/tratamiento-datos/${userId}`);
  return data;
};
